import validator from 'validator';
import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const NumericValidator: (errorMessage: string) => FormValidator = (errorMessage: string) => {
  return async (value: string): Promise<ValidationResult> => {
    if (!value) {
      return { valid: true };
    }

    if (!validator.isNumeric(value, { no_symbols: true })) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
